import React from 'react';
import { useTranslation } from 'react-i18next';
import isEqual from 'lodash/isEqual';
import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  ClearButton,
  DatePicker,
  SelectAccordion,
  SelectDropDown
} from 'components/common/Elements/Elements';

import { createFilterCountry, upFirstLetter } from 'utils/common';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filters,
  selectLoader,
  trigerResetDatePicker,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter
}) => {
  const { t } = useTranslation(['activity']);

  const numberОfFilters = 3;
  let companyCountry = [];
  let dataForAccardionActivities = [];

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  const handleActivity = e => {
    handleFilter({ value: e, target: 'eventName' });
  };

  function checkAndSetFilter(key, value) {
    if (!isEqual(filter[key], value)) {
      setFilter({ ...filter, [key]: value, currentPage: 1 });
      setStartFilter(!startFilter);
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
  }

  const handleDate = value => {
    const key = 'datePeriod';
    checkAndSetFilter(key, value);
  };

  const createFilterActivities = (activities = []) => {
    const shemaList = [];
    activities.forEach(activity => {
      const nameCategory = upFirstLetter(activity.split('.')[2]);
      const nameOption = activity.substr(activity.indexOf('.', 13) + 1);
      if (!shemaList.find(item => item.label.value === nameCategory)) {
        shemaList.push({
          label: {
            value: nameCategory,
            label: nameCategory,
            openGroup: false
          },
          options: []
        });
      }
      const selectCat = shemaList.find(cat => cat.label.value === nameCategory);
      if (selectCat) {
        selectCat.options.push({
          value: activity,
          label: nameOption.replaceAll('.', ' ')
        });
      }
    });
    dataForAccardionActivities = shemaList.filter(
      item => item.options.length > 0
    );
  };

  (function () {
    createFilterCountry(filters.addressCountry, companyCountry);
    createFilterActivities(filters.eventName);
  })();

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <DatePicker
        label={t('activity:filters.ACTIVITY_DATE')}
        input={{
          value: filter.datePeriod,
          onChange: handleDate
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <SelectDropDown
        options={companyCountry}
        input={{ value: filter.addressCountry, onChange: handleFilter }}
        name={'addressCountry'}
        label={t('activity:filters.COUNTRY')}
        searchKeys={['value', 'findName']}
        renderKey={'fullName'}
        checkRenderKey={'fullName'}
        multi
        searchable
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />

      <SelectAccordion
        input={{ value: filter.eventName, onChange: handleActivity }}
        options={dataForAccardionActivities}
        styleStartModeSmall={false}
        title={t('activity:filters.TYPE_OF_ACTIVITY')}
        offTrendline={true}
        trigerReset={trigerResetDatePicker}
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
      />
      <ClearButton
        className={classes.clear}
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string,
  filters: PropTypes.object
};

export default FiltersBlock;
